import { TermsResponse } from "./terms";

export type TermsAction = TermsGetAction | TermsGetSuccessAction;

export const TermsGetActionType = "terms/get" as const;
export type TermsGetAction = ReturnType<typeof termsGetAction>;
export function termsGetAction() {
  return {
    type: TermsGetActionType,
  };
}

export const TermsGetSuccessActionType = "terms/get-success" as const;
export type TermsGetSuccessAction = ReturnType<typeof termsGetSuccessAction>;
export function termsGetSuccessAction(terms: TermsResponse) {
  return {
    type: TermsGetSuccessActionType,
    terms,
  };
}
